import { render, staticRenderFns } from "./pageTabs.vue?vue&type=template&id=33b9d3e6"
import script from "./pageTabs.vue?vue&type=script&lang=js"
export * from "./pageTabs.vue?vue&type=script&lang=js"
import style0 from "./pageTabs.vue?vue&type=style&index=0&id=33b9d3e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports